/**
 * Class Cookie
 */
class Cookie {
    /**
     * @param key
     * @return {any|null}
     */
    static get(key) {
        if (!key) {
            throw new Error('Undefined key.')
        }

        // get cookies trim all inner space and then split by ';'
        // this will return: [ 'key=value', 'key=value' ]
        const allCookies = document.cookie
            .replace(/\s/g, '')
            .split(';');

        // convert array from string to separated arrays with key and value (some sort of tuple)
        // From: [ 'key=value', 'key=value' ] => To: [ [key, value], [key, value] ]
        const convertStringValue = allCookies.map(item => item.split('='));

        // convert tuple to object
        // From:: [ [key, value], [key, value] ] => To: { key: value, key: value }
        const createObjectStringValue = Object.fromEntries(convertStringValue);

        return createObjectStringValue.hasOwnProperty(key)
            ? createObjectStringValue[key]
            : null;
    }

    /**
     * @param key
     * @param value
     * @param days
     * @param extraParameters
     * @return {boolean}
     */
    static set(key, value, days = 1, extraParameters = null) {
        if (!key) {
            throw new Error('Undefined key.');
        }

        if (value === null) {
            throw new Error('Undefined value.');
        }

        const currentValue = this.get(key);

        const date = new Date;
        date.setTime(date.getTime() + 24 * 60 * 60 * 1000 * days);

        document.cookie = `${key}=${value};path=/;expires=${date.toUTCString()}${extraParameters ? extraParameters : ''}`;

        this.$event(key, currentValue, value, !this.checkIfCookieExist(key));

        return true;
    }

    /**
     * @param key
     * @return {boolean}
     */
    static delete(key) {
        if (!key) {
            throw new Error('Undefined key.');
        }

        if (!this.get(key)) {
            return false;
        }

        return this.set(key, '', -1);
    }

    /**
     * @param key
     * @return {boolean}
     */
    static checkIfCookieExist(key) {
        if (!key) {
            throw new Error('Undefined key.');
        }

        return !!this.get(key);
    }

    /**
     * @param cookieName
     * @param oldValue
     * @param newValue
     * @param deleted
     */
    static $event(cookieName, oldValue, newValue, deleted) {
        const customEvent = new CustomEvent(cookieName, {
            detail: {
                cookieName: cookieName,
                oldValue: oldValue,
                newValue: newValue,
                changed: oldValue !== newValue,
                deleted: deleted
            }
        });
        window.dispatchEvent(customEvent);
    }

    /**
     * @param key
     * @param callback
     */
    static $watch(key, callback) {
        if (!key) {
            throw new Error('Undefined key.');
        }

        if (!callback) {
            throw new Error('Define callback.');
        }

        window.addEventListener(key, function (event) {
            callback(event.detail);
        });
    }
}

export default Cookie;